import React from "react";
import { Grid } from "react-bootstrap";
import { connect } from "react-redux";

import { Tab, Tabs } from "material-ui";

import UserList from "./user-list";

const ClientUsers = () => {
    return (
        <Grid
            fluid
            style={{
                height: '100%',
                backgroundColor: 'white',
                overflowY: 'auto',
                paddingBottom: '100px'
            }}
        >
            <Tabs>
                <Tab label="User List">
                    <UserList />
                </Tab>
            </Tabs>
        </Grid>
    )
}

const mapStateToProps = (state) => {}

const mapDispatchToProps = (dispatch) => {}

export default connect(mapStateToProps, mapDispatchToProps)(ClientUsers)